import {createAction, handleActions} from "redux-actions"
import {loadError, loadFinish, loadStart} from 'common/redux/root'
import client from "common/util/http"
import {
  selectLastSearchTime,
  selectSearchConfig, selectSearchConfigOriginAddrOrZip, selectSearchConfigState,
  selectSearchNameFilter
} from "manager/selectors/settlement_provider_search_selectors"

const RESET = 'settlement_provider_search/RESET'
const LOAD = 'settlement_provider_search/LOAD'

export const load = createAction(LOAD)
const reset = createAction(RESET)

export function fetchSettlementProviderSearchConfig(hash, origin_addr_override) {
  return async (dispatch) => {
    dispatch(reset())
    dispatch(loadStart())

    try {
      const response = await client.post('settlement_provider/search_config', {
        data: {
          hash,
          origin_addr_override
        }
      })
      await dispatch(load(response))
      dispatch(loadFinish())

      // now that search config is stored in the, err, store, fire off a default search with no name filter
      dispatch(searchQualiaSettlementAgencies())

    } catch (error) {
      dispatch(loadError(error))
    }

  }
}

export function updateSettlementProviderSearchConfig(new_address) {
  return async(dispatch) => {
    await dispatch(load({'search_config': new_address}))
    dispatch(searchQualiaSettlementAgencies())
  }
}

export function setSettlementProviderSearchNameFilter(name_filter) {
  return (dispatch) => {
    dispatch(load({name_filter}))
  }
}

export function searchQualiaSettlementAgencies() {
  return async (dispatch, getState) => {

    // search for agencies expects some search config to be defined in the store
    const config = selectSearchConfig(getState())
    if (!config) {
      dispatch(loadError("cannot search for settlement agencies w/o a search config"))
      return
    }

    const state = selectSearchConfigState(getState())
    const order_by_distance_from_addr = selectSearchConfigOriginAddrOrZip(getState())

    // the secondary name filter is also defined in th store so that multiple components can access that value
    const filter_by_name = selectSearchNameFilter(getState())

    // search results may arrive out of order, so establish a last searched time as a mechanism to know whether the
    // response is fo the most recent search request
    let search_time = new Date().valueOf()
    dispatch(load({last_settlement_provider_search_time: search_time}))

    dispatch(loadStart())
    dispatch(load({search_results_pending: true}))
    try {
      const response = await client.post('qualia/search_settlement_agencies', {
        data: {
          state,
          order_by_distance_from_addr,
          filter_by_name,
          search_time
        }
      })

      // is this response still for the latest search request?
      const last_settlement_provider_search_time = selectLastSearchTime(getState())
      if (response.search_time === last_settlement_provider_search_time) {
        dispatch(load(response))
        dispatch(load({search_results_pending: false}))
      }

      dispatch(loadFinish())
    } catch (error) {
      dispatch(loadError(error))
    }
  }
}

export function fetchSettlementProviderPlaceOrderDefaults(hash) {
  return async (dispatch) => {
    await dispatch(load({'place_order_defaults': null}))
    dispatch(loadStart())

    try {
      const response = await client.post('settlement_provider/place_order_defaults', {
        data: { hash }
      })
      await dispatch(load(response))
    } catch (error) {
      dispatch(loadError(error))
    } finally {
      dispatch(loadFinish())
    }
  }
}

const initialState = {
  search_config: null,
  name_filter: null,
  last_settlement_provider_search_time: null,
  search_results: null,
  search_results_pending: false,
  place_order_defaults: null,
}

export default handleActions({
  [LOAD]: (state, {payload}) => ({...state, ...payload}),
  [RESET]: (state, {payload}) => ({...initialState}),
}, initialState)
